<template>
      <b-container class="no-gutters">
            <b-col lg="12" class="box-shadow info-container no-gutters">
                  <div class="custom-icon-list">
                        <!--<div v-for="(item) in items.slice(0, limit_by)" v-bind:key="item.id" >
                            <component v-bind:is="item.component" v-bind:iconStyle="'small'" v-bind:topIconSize="'1x'" v-bind:bottomIconSize="'2x'" class="custom-category-icon-container" />
                        </div>-->
                      <img class="mx-auto icon-img" :src="this.image_name" alt="Group_217"/>
                  </div>
                  <div class="info-text-container">
                        <h1 class="info_title palette-white">{{ $t('info.container_title')}}</h1>
                        <p class="info_body">{{ $t('info.container_body')}}</p>
                        <b-button class="info_button" @click.stop="showInfo">
                            {{ $t('info.read_more')}}
                        </b-button>
                  </div>
            </b-col>
      </b-container>
</template>

<script>
export default {
  name: "InfoContainer",
  methods: {
      onResize() {
         if (window.innerWidth < 768) {
             this.image_name = require('../../assets/Group_217_sm.png')
         } else {
             this.image_name = require('../../assets/Group_217.png')
         }
      },
      showInfo: function () {
          this.$router.push({name: 'info-view'})
      }
  },
  created() {
      window.addEventListener('resize', this.onResize)
      if (window.innerWidth < 768) {
          this.image_name = require('../../assets/Group_217_sm.png')
      } else {
          this.image_name = require('../../assets/Group_217.png')
      }
  },
  beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
  },
  data: function () {
        return {
            image_name: require('../../assets/Group_217.png'),
        }
  }
}
</script>

<style scoped>

</style>